import oauthService from '@/_service/oauth.service'
import { IRedux } from '@/_store/types'
import { toaster } from '@/components/ui/toaster'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@chakra-ui/react'
import styles from './Google.module.css'

export default function GoogleBtn({
  onSuccess,
}: {
  onSuccess: (data: any) => void
}) {
  const settings = useSelector((state: IRedux) => state.settings.data)

  const origin = 'https://auth.delever.uz'

  const responseMessage = (response: { credential: string }) => {
    oauthService
      .signIn({
        token: response?.credential,
        shipper_id: settings?.shipper_id,
      })
      .then((res) => {
        onSuccess(res.data)
      })
      .catch(() => {
        oauthService
          .signUp({
            token: response?.credential,
            shipper_id: settings?.shipper_id,
          })
          .then((res) => {
            onSuccess(res.data)
          })
          .catch(() => {
            toaster.create({ title: 'something went wrong!' })
          })
      })
  }

  useEffect(() => {
    const handleAuthMessage = (event: MessageEvent) => {
      // Security check
      if (event.origin !== origin) return

      if (event.data.type === 'AUTH_SUCCESS') {
        responseMessage(event.data)
      }

      if (event.data.type === 'AUTH_CANCEL') {
        toaster.create({ title: 'something went wrong!' })
      }
    }

    window.addEventListener('message', handleAuthMessage)
    return () => window.removeEventListener('message', handleAuthMessage)
  }, [])

  return (
    <Box
      width='100%'
      height='56px'
      bg='transparent'
      borderRadius='md'
      overflow='hidden'
      position='relative'
      className={styles.iframeContainer}
    >
      <iframe
        src={origin + `?source=${window.location.hostname}`}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          mixBlendMode: 'multiply',
          background: 'transparent',
          backgroundColor: 'transparent',
        }}
        allow='identity-credentials-get'
        allowTransparency={true}
      />
    </Box>
  )

  // return (
  //   <Button size="xl" height="56px" variant="outline" loading={false}>
  //     <FcGoogle />
  //     Продолжить с Google
  //   </Button>
  // )
}
